import { Box, Typography, useTheme } from "@mui/material";
import { ReactElement } from "react";
import { Link } from "react-router-dom";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";

interface Props {
  title?: string;
  icon?: ReactElement;
  path?: string;
  index?: number;
}

export default function LinkCard({ icon, title, path, index }: Props) {
  const theme = useTheme();

  return (
    <Link
      to={"/"}
      style={{
        width: "70%",
        borderRadius: "8px",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor:
          index === 2
            ? theme.palette.secondary.main
            : theme.palette.primary.main,
        padding: 16,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {icon}
        <Typography
          sx={{
            maxWidth: "90%",
            color: "background.default",
            fontSize: "16px",
          }}
        >
          {title}
        </Typography>
      </Box>

      <ArrowLeft />
    </Link>
  );
}
